import type { TaskStatus } from 'src/app/shared/models/todo.model';

export type { TaskStatus };
export enum UserRole {
  User = 'User',
  Counsellor = 'Counsellor',
  Admin = 'Admin',
  ContentCreator = 'ContentCreator'
}

/** Payload for admin-side user creation (POST /users/register, guarded). */
export interface CreateUserDTO {
  name: string;
  email: string;
  password?: string;
  roles?: string[];
}
  
export interface User {
  roles: UserRole[];
  _id: string;
  name: string;
  oldId: string;
  email: string;
  uuid: string;
  activity: string;
  isApproved: boolean;
  customTasks: customTask[];
  favorites: Favorite[];
  tasks: Task[];
  irrelevantResults: Irrelevant[];
  history: any[];
  onboardingBannerDismissedAt?: string | null;
}

export const TASK_STATUS_VALUES: TaskStatus[] = ['TODO', 'IN_PROGRESS', 'ARCHIVED'];

export interface customTask {
  id?: string;
  title: string;
  done: boolean;
  checklist: { name: string, done: boolean }[];
  status: TaskStatus;
}

export interface Favorite {
  vid: number;
  rid: number;
}

export interface Irrelevant {
  vid: number;
  rid: number;
}

export interface Task {
  vid: number;
  rid: number;
  checklist: {
    id: number;
    done: boolean;
  }[];
  status: TaskStatus;
}

  export type rightNames = 'READ' | 'CREATE' | 'UPDATE' | 'DELETE' | 'PUBLISH';
  
  export type documentNames =
    | 'EVENTS'
    | 'RESULTS'
    | 'LOCATIONS'
    | 'USERS'
    | 'INSURANCES'
    | 'REGIONS'
    | 'ACTIONS';

  export type right = `${documentNames}_${rightNames}`;
